import Cookies from 'js-cookie'
import { fmUserLogin, fmUserChangeUserPwd, loginInfo, authorize, oktaToken, selectUserForResetPassword, sendDigit, resetPasswordToken, getResetPassword, getOperationManual, getOperationManualDowload} from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
let sideMenus = []
let routers = []
let fmMenus = []
//
function loginData(data) {
  window.sessionStorage.setItem('menus', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/index/index',
    menuName: '我的任务',
    menuNameEn: 'My task',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'lvmh slp',
    menuNameEn: 'lvmh slp',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/
/**
 * 查找指定级别的第一个菜单，如查找第一个二级菜单，则参数：menus， level=2
 * @param menus
 * @param level
 */
function findFistMenu(menus) {
  if (menus == null) {
    return null;
  }
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].hasChild == 'N') {
      return menus[i];
    } else {
      return findFistMenu(menus[i].childMenus);
    }
  }
}

function dealPath(menuNameNick) {
  while (menuNameNick.indexOf('/') > -1) {
    menuNameNick = menuNameNick.replace('/', '_')
  }
  // menuNameNick = bus.replaceAll('/', '_');
  menuNameNick = '/' + menuNameNick
  return menuNameNick
}
const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null,
    oktaData: null,
    oktaTokenData: null,
    selectResetPasswordObj: null,
    sendDigitObj: null,
    resetPasswordTokenObj: null,
    resetPasswordObj: null,
    slpLogin: null,
    OperationManualObj: null,
    OperationManualDownLoadObj: null
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers;
      state.slpLogin = data;
      if (!data.menus){
        Message({
          showClose: true,
          message: "当前账号【"+ data.user.userNo + "】未分配角色!",
          type: 'error'
        })
        return;
      }
      if (data.menus.childMenus != null && data.menus.childMenus.length > 0) {
        let firstMenu = findFistMenu(data.menus.childMenus);
        if (firstMenu != null) {
          localStorage.setItem('firstMenuPath', dealPath(firstMenu.menuNameNick));
          localStorage.setItem('firstMenuName', firstMenu.menuName);
        }
      }
      state.clients = data.clients
      sessionStorage.setItem('clients', JSON.stringify(data.clients))
      sessionStorage.setItem('user', JSON.stringify(data.user))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    },
    OKTA_AUTHORIZE: (state, obj) => {
      state.oktaData = obj
    },

    //okta-获取token
    OKTA_TOKEN: (state, data) => {
      state.oktaTokenData = data
      state.addRouters = routers;
      let dataParams =  data.obj;
      if (!dataParams.menus){
        Message({
          showClose: true,
          message: "当前账号【"+ dataParams.user.userNo + "】未分配角色!",
          type: 'error'
        })
        return;
      }
      if (dataParams.menus.childMenus != null && dataParams.menus.childMenus.length > 0) {
        let firstMenu = findFistMenu(dataParams.menus.childMenus);
        if (firstMenu != null) {
          localStorage.setItem('firstMenuPath', dealPath(firstMenu.menuNameNick));
          localStorage.setItem('firstMenuName', firstMenu.menuName);
        }
      }
      state.clients = dataParams.clients
      sessionStorage.setItem('clients', JSON.stringify(dataParams.clients))
      sessionStorage.setItem('user', JSON.stringify(dataParams.user))
    },
    SELECT_USER_FOR_RESET_PASSWORD: (state, data) => {
      state.selectResetPasswordObj = data
    },
    SEND_DIGIT: (state, data) => {
      state.sendDigitObj = data
    },
    RESET_PASSWORD_TOKEN: (state, data) => {
      state.resetPasswordTokenObj = data
    },
    GET_RESET_PASSWORD: (state, data) => {
      state.resetPasswordObj = data
    },
    GET_OPERATION_MANUAL: (state, data) => {
      state.OperationManualObj = data
    },
    GET_OPERATION_MANUAL_DOWLOAD: (state, data) => {
      state.OperationManualDownLoadObj = data
    },
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { refreshToken, token } = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem('changeUser', 'N');
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },
    //切换账号
    async loginInfo({ dispatch, commit }, data) {
      let res = await loginInfo(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { user } = obj;

        obj.refreshToken = localStorage.getItem("refresh");
        obj.token = localStorage.getItem("token");
        obj.clients = JSON.parse(sessionStorage.getItem('clients'));

        sideMenus = []
        routers = []
        fmMenus = []

        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem("ms_username", user.userNo);
        localStorage.setItem("token", obj.token);
        localStorage.setItem("refresh", obj.refreshToken);

        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },

    //域登录
    async authorize({ commit }, data) {
      const res = await authorize(data)
      commit('OKTA_AUTHORIZE', res)
    },

    //token
    async oktaToken({ commit }, data) {
      const res = await oktaToken(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { refreshToken, token } = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem('changeUser', 'N');
        filterAsyncRouter(obj)
        commit('OKTA_TOKEN', res);
      }
    },

    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    },

    async selectUserForResetPassword({ commit }, obj) {
      const resp = await selectUserForResetPassword(obj)
      commit('SELECT_USER_FOR_RESET_PASSWORD', resp)
    },

    async sendDigit({ commit }, obj) {
      const resp = await sendDigit(obj)
      commit('SEND_DIGIT', resp)
    },
    //获取token
    async resetPasswordToken({ commit }, obj) {
      const resp = await resetPasswordToken(obj)
      commit('RESET_PASSWORD_TOKEN', resp)
    },
    //根据邮件重置密码
    async getResetPassword({ commit }, obj) {
      const resp = await getResetPassword(obj)
      commit('GET_RESET_PASSWORD', resp)
    },
    //操作手册查询
    async getOperationManual({ commit }, obj) {
      const resp = await getOperationManual(obj)
      commit('GET_OPERATION_MANUAL', resp)
    },
    //操作手册下载
    async getOperationManualDowload({ commit }, obj) {
      const resp = await getOperationManualDowload(obj)
      commit('GET_OPERATION_MANUAL_DOWLOAD', resp)
    },
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js